import React from 'react';
import TextQuestion from './TextQuestion';
import ChoiceQuestion from './ChoiceQuestion';
import StatementQuestion from './StatementQuestion';
import FiveStarReviewQuestion from './FiveStarReviewQuestion';
import DatePickerQuestion from './DatePickerQuestion';
import FileUploadQuestion from './FileUploadQuestion';
import { QUESTION_TYPES } from '../../constants/question-types';

/**
 * Renders the appropriate question component based on question type
 */
const QuestionRenderer = (props) => {
  const { question } = props;

  switch (question.type) {
    case QUESTION_TYPES.SHORT_TEXT:
      return <TextQuestion {...props} isParagraph={false} />;

    case QUESTION_TYPES.PARAGRAPH:
      return <TextQuestion {...props} isParagraph={true} />;

    case QUESTION_TYPES.MULTIPLE_CHOICE:
      return <ChoiceQuestion {...props} questionType={QUESTION_TYPES.MULTIPLE_CHOICE} />;

    case QUESTION_TYPES.CHECKBOX:
      return <ChoiceQuestion {...props} questionType={QUESTION_TYPES.CHECKBOX} />;

    case QUESTION_TYPES.DROPDOWN:
      return <ChoiceQuestion {...props} questionType={QUESTION_TYPES.DROPDOWN} />;

    case QUESTION_TYPES.STATEMENT:
      return <StatementQuestion {...props} />;

    case QUESTION_TYPES.FIVE_STAR_REVIEW:
      return <FiveStarReviewQuestion {...props} />;

    case QUESTION_TYPES.DATE_PICKER:
      return <DatePickerQuestion {...props} />;

    case QUESTION_TYPES.FILE_UPLOAD:
      return <FileUploadQuestion {...props} />;

    default:
      return (
        <div className="alert alert-warning">
          Unknown question type: {question.type}
        </div>
      );
  }
};

export default QuestionRenderer;
